var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1308_1573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6251 12C21.6248 11.4483 21.5746 10.8977 21.4751 10.355L24.5181 8.6L21.5181 3.4L18.4741 5.159C17.6336 4.43993 16.6678 3.88194 15.6251 3.513V0H9.62506V3.513C8.58231 3.88194 7.61651 4.43993 6.77606 5.159L3.73206 3.4L0.732056 8.6L3.77506 10.355C3.57517 11.4426 3.57517 12.5574 3.77506 13.645L0.732056 15.4L3.73206 20.6L6.77606 18.842C7.61659 19.5607 8.58239 20.1184 9.62506 20.487V24H15.6251V20.487C16.6678 20.1181 17.6336 19.5601 18.4741 18.841L21.5181 20.6L24.5181 15.4L21.4751 13.645C21.5746 13.1023 21.6248 12.5517 21.6251 12ZM15.6251 12C15.6251 12.5933 15.4491 13.1734 15.1195 13.6667C14.7898 14.1601 14.3213 14.5446 13.7731 14.7716C13.2249 14.9987 12.6217 15.0581 12.0398 14.9424C11.4578 14.8266 10.9233 14.5409 10.5037 14.1213C10.0842 13.7018 9.79846 13.1672 9.6827 12.5853C9.56694 12.0033 9.62635 11.4001 9.85342 10.8519C10.0805 10.3038 10.465 9.83524 10.9583 9.50559C11.4517 9.17595 12.0317 9 12.6251 9C13.4207 9 14.1838 9.31607 14.7464 9.87868C15.309 10.4413 15.6251 11.2044 15.6251 12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1308_1573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsOn);
export default __webpack_public_path__ + "static/media/settingsOn.3c15d6e786ea3f3769f98a92d9b4d3ea.svg";
export { ForwardRef as ReactComponent };